import styles from "./NotificationModal.module.css";
import Button from "../Button";
import classNames from "classnames";

export interface INotificationModalProps {
  title?: string;
  description?: string;
  actionLabel?: string;
  open: boolean;
  className?: string;
  onClose?: () => void;
  onAction?: () => void;
  image?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  loading?: boolean;
  closeLabel?: string;
}

const NotificationModal = (props: INotificationModalProps) => {
  return (
    <article className={`${styles.modal} ${props.open && styles.isOpen} ${props.className}`}>
      <div className={styles.modalContainer}>
        <div className={styles.content}>
          {props.image && <props.image />}
          {props.title && <h3 className={styles.title}>{props.title}</h3>}
          {props.description && <p
            className={styles.description}
            dangerouslySetInnerHTML={{
              __html: props.description ?? "",
            }}
          >
          </p>}
        </div>
        {(props.actionLabel || props.closeLabel) && (
          <div className={styles.buttonsContainer}>
            {
              (props.onClose && props.closeLabel) 
              &&
              <Button className={styles.button} variant="plain" onClick={props.onClose}>
                {props.closeLabel}
              </Button>
            }
            {
              props.onAction
              &&
              <Button loading={props.loading} disabled={props.loading} className={styles.button} variant="primary"
                onClick={props.onAction ?? props.onClose}>
                {props.actionLabel}
              </Button>
            }
          </div>
        )}
      </div>
    </article>
  );
};

export default NotificationModal;
